
export const content = {
  title: "Digital Content",
  details: {
    backToContent: "Back to Content",
    purchase: "Purchase Now",
    downloadNow: "Download Now"
  },
  loading: "Loading content...",
  backToList: "Back to Content List",
  requestForm: {
    title: "What digital content would you like to see?",
    description: "If there's any content you'd like to see, let us know and we'll try to make it happen!",
    placeholder: "E.g.: I'd like a funny emoji pack...",
    submit: "Submit",
    sent: "Sent!"
  }
};
